import Vue from 'vue';
import _ from 'lodash';

const INIT_STATE = {
  id: '',
  email: '',
  name: '',
  dob: '',
  mobileNumber: '',
  telephoneNumber: '',
  businessName: '',
  abnNumber: '',
  subAggregator: '',
  businessAddress: '',
  postalAddress: '',
  aclNumber: '',
  acrNumber: '',
  insuranceUrl: '',
  membershipUrl: '',
  bankName: '',
  bsb: '',
  bankAccountNumber: '',
  password: '',
  aggregator: {},
};

// stripped submit fields
const strippedSubmitFields = ['aggregator'];

const state = {
  ...INIT_STATE,
};

const getters = {};

const actions = {
  setId({commit}, id) {
    return commit({type: 'setId', id});
  },
  submitForm({commit}, type = 'aggregator') {
    let endpoint = 'aggregator/broker-creation';
    return new Promise((resolve, reject) =>
      Vue.http.post(endpoint, _.omit(state, strippedSubmitFields)).then(
        response => {
          resolve(response);
          commit('resetState');
        },
        error => {
          reject(error);
        }
      )
    );
  },
};

const mutations = {
  setId(state, payload) {
    state.id = payload.id;
  },
  setField(state, payload) {
    state[payload.field] = payload.value;
  },
  setFields(state, payload) {
    state = Object.assign(state, payload.values);
  },
  resetState(state) {
    Object.assign(state, INIT_STATE);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/broker.js